import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Modal,
  Box,
  CircularProgress,
  Paper,
  Grid
} from "@mui/material";

import {
  Texto,
  buttonGuardar,
  SubTitulodos,
  TituloColor,
  Input,
  modalStyle, 
  buttonCancelar 
} from "../../Layouts/CustomStyles";
import { useServiciosClinicos, useGetServiciosClinicos } from "../../Services/ServicioClinico";
import { FaTrashCan } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";

export const ServicioClinicosArea = ({ openDialog, onCloseDialog }) => {
  const{postServicioClinico, eliminarServicioClinico} =useServiciosClinicos();
  const {servicios, loadings, refetch} = useGetServiciosClinicos();
  const [nombre, setNombre] = useState("");
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
   const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedServicio, setSelectedServicio] = useState(null);

  const handleOpenConfirm = (servicio) => {
    setSelectedServicio(servicio);
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setSelectedServicio(null);
  };

  const handleConfirmDelete = async () => {
     setEnviandoAlert(true);
    try {
      await eliminarServicioClinico(selectedServicio.id);
      await refetch();
       setAlertMessage("Área clínica eliminado exitosamente.");
    setSuccessAlertOpen(true);
    handleCloseConfirm()
    } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Error eliminando servicio";

    setAlertMessage(message);
    setErrorAlertOpen(true);
  } finally {
    setEnviandoAlert(false);
  }
  };


  const handleSubmit = async (e) => {
  e.preventDefault();
  setEnviandoAlert(true);
  try {
    await postServicioClinico({ nombre });
    setNombre("");
    setAlertMessage("Área clínica creado exitosamente.");
    setSuccessAlertOpen(true);
    onCloseDialog();
    await refetch();
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Error al crear Área clínica";

    setAlertMessage(message);
    setErrorAlertOpen(true);
  } finally {
    setEnviandoAlert(false);
  }
};


  return (
    <>
      <Box>
        <Grid container spacing={2}>
        {loadings ? (
          // 🌀 Mostrar spinner mientras carga
          <Grid size={{ xs: 12 }} display="flex" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
            <CircularProgress />
          </Grid>
        ) : servicios.length > 0 ? (
          servicios.map((u) => (
            <Grid size={{ xs: 12, sm: 6 }} key={u.id}>
              <Paper
                elevation={2}
                sx={{
                  padding: "20px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#fff",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <Box display="flex" alignItems="center">
                  <Typography sx={Texto}>{u.nombre}</Typography>
                </Box>

                <button className="delete-button" onClick={() => handleOpenConfirm(u)}>
                  <FaTrashCan className="delete-svgIcon" />
                </button>
              </Paper>
            </Grid>
          ))
        ) : (
          <Grid size={{ xs: 12 }}>
            <Typography sx={{ textAlign: "center", color: "#888" }}>
              No hay áreas registradas
            </Typography>
          </Grid>
        )}
      </Grid>
      </Box>

      <Dialog open={openDialog} onClose={onCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle sx={TituloColor}>Agregar Nuevo Servicio Clínico</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <TextField
              label="Nombre del Servicio"
              value={nombre}
              sx={Input}
              onChange={(e) => setNombre(e.target.value)}
              fullWidth
              required
              margin="dense"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onCloseDialog} sx={buttonCancelar}>Cancelar</Button>
            <Button type="submit" sx={buttonGuardar}>
              Guardar
            </Button>
          </DialogActions>
        </form>
      </Dialog>

       <Dialog open={openConfirm} onClose={handleCloseConfirm}>
        <DialogTitle sx={TituloColor}>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <Typography sx={SubTitulodos}>
            ¿Estás seguro de que deseas eliminar el área clínica{" "}
            <strong>{selectedServicio?.nombre}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} sx={buttonCancelar}>
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} sx={buttonGuardar}>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

       <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                          <Box sx={modalStyle}>
                              <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                                  <IoClose />
                              </section>
                              <section style={{ textAlign: "center" }}>
                                  <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                                  <p className="alert-text">{alertMessage}</p>
                              </section>
                          </Box>
                      </Modal>
      
                      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                          <Box sx={modalStyle}>
                              <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                  <IoClose />
                              </section>
                              <section style={{ textAlign: "center" }}>
                                  <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                                  <p className="alert-text">{alertMessage}</p>
                              </section>
                          </Box>
                      </Modal>
      
                      <Modal open={enviandoAlert}>
                          <Box sx={modalStyle}>
                              <section style={{ textAlign: "center", padding: "1rem" }}>
                                  <CircularProgress style={{ color: "#2a8d74" }} />
                                  <p className="alert-text">Procesando solicitud...</p>
                              </section>
                          </Box>
                      </Modal>
    </>
  );
};
